// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { useMergeRefs } from '@amzn/awsui-component-toolkit/internal';
import { getBaseProps } from '../internal/base-component';
import { flattenChildren } from '../internal/utils/flatten-children';
import WithNativeAttributes from '../internal/utils/with-native-attributes';
import styles from './styles.css.js';
const InternalSpaceBetween = forwardRef(({ direction = 'vertical', size, children, alignItems, nativeAttributes, __internalRootRef, ...props }, ref) => {
    const mergedRef = useMergeRefs(ref, __internalRootRef);
    const baseProps = getBaseProps(props);
    /*
   Flattening the children allows us to "see through" React Fragments and nested arrays.
   */
    const flattenedChildren = flattenChildren(children, 'SpaceBetween');
    const propagateAlignment = alignItems && direction === 'horizontal';
    return (React.createElement(WithNativeAttributes, { ...baseProps, tag: "div", componentName: "SpaceBetween", nativeAttributes: nativeAttributes, className: clsx(baseProps.className, styles.root, styles[direction], styles[`${direction}-${size}`], alignItems && styles[`align-${alignItems}`]), ref: mergedRef }, flattenedChildren.map(child => {
        // If this react child is a primitive value, the key will be undefined
        const key = child && typeof child === 'object' ? child.key : undefined;
        return (React.createElement("div", { key: key ? String(key) : undefined, className: clsx(styles.child, propagateAlignment && styles['child-aligned']) }, child));
    })));
});
export default InternalSpaceBetween;
//# sourceMappingURL=internal.js.map